export default {
  meta: {
    title: '模拟品牌'
  }
};
